import {
  BR_STATUS,
  getItemStatusCode,
  getLatestBrSubmission,
  resolveBrDisplayStatus,
} from './brDocumentCore';
import { isBrFeatureEnabled } from './brConfig';
import {
  brRuntimeState,
  fetchKybAccessGate,
  isKybAccessGatePending,
  isKybLockedByCache,
} from './brRuntime';

function normalizeRoutePath(path) {
  const raw = String(path || '').trim();
  if (!raw) {
    return '/';
  }
  const withoutQuery = raw.split('?')[0].split('#')[0];
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.replace(/\/+$/, '');
  }
  return withoutQuery;
}

export function describeBrLockedLanding(items = brRuntimeState.documentList) {
  const latest = getLatestBrSubmission(items);
  if (!latest) {
    return {
      landingUrl: '/businessDocuments/addDocument',
      landingReason: 'no_br_record',
      latestStatusCode: null,
      latestDisplayStatus: null,
    };
  }
  const code = getItemStatusCode(latest);
  const displayStatus = resolveBrDisplayStatus(latest);
  if (code === BR_STATUS.REJECTED) {
    return {
      landingUrl: '/businessDocuments/addDocument',
      landingReason: 'rejected',
      latestStatusCode: code,
      latestDisplayStatus: displayStatus,
    };
  }
  return {
    landingUrl: '/businessDocuments/default',
    landingReason: displayStatus || code,
    latestStatusCode: code,
    latestDisplayStatus: displayStatus,
  };
}

export function isBrLockExemptUser(user) {
  if (!user) {
    return false;
  }
  if (user.userType === 'ADMIN' || user.IsFullAccess === true) {
    return true;
  }
  return String(user.userRole || '').toLowerCase() === 'admin';
}

export function shouldLockSidebarForBr(user) {
  if (!isBrFeatureEnabled() || isBrLockExemptUser(user)) {
    return false;
  }
  // 冷启动拉 gate 中：先挡住菜单，避免误点；有旧 gate 时不进此态（SWR）
  if (isKybAccessGatePending()) {
    return true;
  }
  const lockedByGate = isKybLockedByCache();
  // 未知则从严：避免 AccessGate 未就绪时短暂 fail-open 解锁
  return lockedByGate !== false;
}

export function resolveBrLockedLandingRoute(items = brRuntimeState.documentList) {
  return describeBrLockedLanding(items).landingUrl;
}

export function isRouteKybExempt(route) {
  if (!route) {
    return false;
  }
  if (Array.isArray(route.matched) && route.matched.some((r) => r.meta && r.meta.kybExempt === true)) {
    return true;
  }
  const path = normalizeRoutePath(route.path);
  return path.indexOf('/businessDocuments') === 0
    || path.indexOf('/management') === 0
    || path.indexOf('/Management') === 0
    || path.indexOf('/auth') === 0
    || path.indexOf('/authentication') === 0;
}

/**
 * 导航守卫：AccessGate 不允许则返回落地 path。
 * AccessGate 失败时一律跳商业文件页（严处理，无单独开关）。
 */
export async function resolveKybNavigationRedirect(user, route, { forceRefresh = false } = {}) {
  if (!isBrFeatureEnabled() || isBrLockExemptUser(user) || isRouteKybExempt(route)) {
    return null;
  }
  const gate = await fetchKybAccessGate(user, { force: forceRefresh });
  if (!gate) {
    return describeBrLockedLanding().landingUrl || '/businessDocuments/default';
  }
  if (!gate.featureEnabled || !gate.lockActive || gate.allowed) {
    return null;
  }
  return describeBrLockedLanding().landingUrl || gate.landingPath || '/businessDocuments/default';
}

export function shouldRedirectLockedBrRoute(user, route) {
  // gate 确认中不强制跳转，避免登录瞬间弹到商业文件页再跳回
  if (isKybAccessGatePending()) {
    return null;
  }
  if (!shouldLockSidebarForBr(user) || isRouteKybExempt(route)) {
    return null;
  }
  return resolveBrLockedLandingRoute();
}
